// extracted by mini-css-extract-plugin
module.exports = {"model":"model___1fKEv","center":"center___1PMYn","spin":"spin___3Rksd"};